import React, { useState } from 'react'
import { Button, Col, Row } from 'reactstrap';

//Helpers
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';

//Contants
import { actionsTable } from '../../../../constants/MaterialTable';

//Components
import TextField from '../../../../components/TextField/TextField';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { showQuestion } from 'helpers/message';

//estado inicial do documento
function initialStateDocumento() {
  return {
    identificacao: "",
    descricao: "",
    obrigatorio: "true",
    deletado: false
  }
}

export default function Documentos({ formulario, setFormulario }) {
  //Estado que guarda os dados do documento para cadastrar/editar
  const [documento, setDocumento] = useState(initialStateDocumento());

  //Estado de controle dos erros nos campos obrigatorios
  const [errors, setErrors] = useState({});

  //Campos obrigatorios do formulario de documento
  const campos = [
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "descricao", required: true }),
    objCampo({ name: "obrigatorio", required: true })
  ];


  //Opções para o select de status
  const optionsStatus = [
    { text: "Sim", value: "true" },
    { text: "Não", value: "false" },
  ];

  //Cabeçalhos da tabela de listagem
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Descrição", objectValue: "descricao", align: "left" },
    {
      value: "Obrigatório", objectValue: "obrigatorio", options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return formulario.tbFormularioPGRSDocumentos[dataIndex]?.obrigatorio == "true" ? "Sim" : "Não";
        }
      }
    }
  ];


  //Função que executa o procedimento de edição ao clicar no botão da tabela
  const editarDocumento = (item) => {
    setDocumento(item);
  }

  const removerDocumento = (_questao, confirmacao) => {
    if (!confirmacao) return;

    setFormulario({ ...formulario, tbFormularioPGRSDocumentos: [...formulario.tbFormularioPGRSDocumentos.filter((item, index) => index != _questao.tableData.id)] })
  }

  const actions = [
    actionsTable.editar(editarDocumento),
    actionsTable.remover((rowData) => {
      showQuestion(
        "Tem certeza disso?", "Você tem certeza de que deseja remover esta questão? Esta é uma ação irreversível",
        "warning",
        (confirmation) => removerDocumento(rowData, confirmation)
      );
    })];

  //OnChange dos campos do documento
  const onChangeDocuemnto = (e) => {
    const { name, value } = e.target;
    const _documento = {
      ...documento,
      [name]: value
    }
    const campo = campos.filter(c => c.name === name);
    const erros = validarCampos(_documento, campo);
    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    } else {
      setErrors({ ...errors, ...erros[0] })
    }

    setDocumento(_documento)
  }

  //Função que faz o cadastro / edição do documento
  const addDocumento = () => {
    const erros = validarCampos(documento, campos);
    setErrors(erros[0]);

    if (erros[1].length > 0) {
      return;
    }

    const _documento = { ...documento };
    let _formularioPGRSDocumentos;

    if (_documento.tableData) {
      _formularioPGRSDocumentos = formulario.tbFormularioPGRSDocumentos.filter(
        (bloco, index) => index != _documento.tableData.id
      );
      _formularioPGRSDocumentos = [..._formularioPGRSDocumentos, { ..._documento }];
    } else
      _formularioPGRSDocumentos = [...formulario.tbFormularioPGRSDocumentos, { ..._documento }];

    _formularioPGRSDocumentos.sort((a, b) => (a.identificacao > b.identificacao ? 1 : -1));

    setFormulario({
      ...formulario,
      tbFormularioPGRSDocumentos: _formularioPGRSDocumentos,
    });

    setDocumento(initialStateDocumento());
  }

  return (
    <div className='p-2 m-2'>
      <div className={`formContainer mb-4`}>
        <Row>
          <Col lg={8}>
            <TextField
              maxLength={"150"}
              invalid={!!errors.identificacao}
              label={"* Identificação"}
              name="identificacao"
              value={documento.identificacao}
              onChange={onChangeDocuemnto}
            />
          </Col>
          <Col lg={4}>
            <TextField
              invalid={!!errors.obrigatorio}
              label={"* Obrigatório"}
              name="obrigatorio"
              type={"select"}
              options={optionsStatus}
              value={documento.obrigatorio}
              onChange={onChangeDocuemnto}
            />
          </Col>
          <Col lg={12}>
            <TextField
              invalid={!!errors.descricao}
              label={"* Descrição"}
              type={"textarea"}
              name="descricao"
              value={documento.descricao}
              onChange={onChangeDocuemnto}
              maxLength={300}
            />
          </Col>
        </Row>
        <div className='mt-3 d-flex justify-content-center align-items-center'>
          <Button color={'success'} onClick={addDocumento}>
            <FontAwesomeIcon icon={faSave} /> Salva
          </Button>
        </div>
      </div>
      <div className="mt-4">
        <TabelaListagem
          actions={actions}
          title={"Lista de Documentos"}
          options={{ print: false, search: true, pagination: true }}
          headers={headers}
          items={formulario?.tbFormularioPGRSDocumentos ?? []}
        />
      </div>

    </div>
  )
}
